module.exports = __webpack_public_path__ + "static/media/icn_composer_60x60.9d61952b.svg";